<template>
  <b-row>
    <b-col cols="12">
      <job-level-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import JobLevelContent from './JobLevelContent.vue'

export default {
  components: {
    BRow,
    BCol,

    JobLevelContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>